export default "__VITE_ASSET__Brck4QZw__"